// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1DHhy","left":"InfoRow_left__2Bm1g"};